import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type PlayButtonInverseProps = {
    className?: string;
};

const PlayButtonInverse: FunctionComponent<PlayButtonInverseProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'play-button-inverse'}
            viewBox="0 0 250 250"
        >
            <path d="M125 0C56 0 0 56 0 125s56 125 125 125 125-56 125-125S194 0 125 0zm8 150.4l-49.9 25.4V74.1L133 99.6l49.9 25.4-49.9 25.4z" />
        </svg>
    );
};

export default PlayButtonInverse;
